import {
  usePopoverDisclosureArrow
} from "./LVMO37QD.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  __objRest,
  __spreadValues
} from "./PNRLI7OV.js";

// src/select/select-arrow.ts
var useSelectArrow = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = usePopoverDisclosureArrow(__spreadValues({ store }, props));
    return props;
  }
);
var SelectArrow = createComponent((props) => {
  const htmlProps = useSelectArrow(props);
  return createElement("span", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  SelectArrow.displayName = "SelectArrow";
}

export {
  useSelectArrow,
  SelectArrow
};
